function filterShades(context) {
  const skinToneFilter = context.querySelector('input[name="skin-tone"]');
  const underToneFilter = context.querySelector('input[name="undertone"]');
  if (!skinToneFilter || !underToneFilter) return;
  const selectedShade = context.querySelector('input[name="skin-tone"]:checked')?.value;
  const selectedUndertone = context.querySelector('input[name="undertone"]:checked')?.value;

  function filterAttributes() {
    const existedSt = [];
    const existedUt = [];

    context.querySelectorAll(".attr-main-wrapper").forEach((element) => {
      const dataSt = element.dataset.st;
      const dataUt = element.dataset.ut;
      if (!dataSt && !dataUt) return;
      const showByShade = dataSt === selectedShade || selectedShade === "All";
      const showByUndertone = dataUt === selectedUndertone || selectedUndertone === "All";
      element.classList.toggle("hide-shade", !(showByShade && showByUndertone));
    });

    function toggleExistedAttributes(selector, existedAttributes) {
      context.querySelectorAll(selector).forEach((element) => {
        element.classList.toggle("disabled", !existedAttributes.includes(element.value) && element.value !== "All");
      });
    }

    // 1. Find all undertones related to the selected skin tone
    context
      .querySelectorAll(
        `.attr-main-wrapper${selectedShade === "All" ? "[data-st]" : '[data-st*="' + selectedShade + '"]'}`,
      )
      .forEach((element) => {
        const dataUt = element.dataset.ut;
        if (!existedUt.includes(dataUt)) {
          existedUt.push(dataUt);
        }
      });
    toggleExistedAttributes(".undertone-options .shade-option", existedUt);

    // 2. Find all skin tones related to the selected undertone
    context
      .querySelectorAll(
        `.attr-main-wrapper${selectedUndertone === "All" ? "[data-ut]" : '[data-ut*="' + selectedUndertone + '"]'}`,
      )
      .forEach((element) => {
        const dataSt = element.dataset.st;
        if (!existedSt.includes(dataSt)) {
          existedSt.push(dataSt);
        }
      });
    toggleExistedAttributes(".skin-tone-options .shade-option", existedSt);
  }

  // Initial filter based on the default selected options
  filterAttributes();
}

var setupTonePicker = function (context = document) {
  function updateSelection(event) {
    const name = event.target.name;
    context.querySelectorAll(`input[name="${name}"]`).forEach((radio) => (radio.checked = false));
    event.target.checked = true;
    filterShades(context);
  }
  context.querySelectorAll('input[name="skin-tone"], input[name="undertone"]').forEach((radio) => {
    radio.addEventListener("click", updateSelection);
  });
};

document.addEventListener("DOMContentLoaded", function () {
  setupTonePicker(); // PDP
  document.querySelectorAll("quick-add-modal").forEach((modal) => {
    // QUICK VIEW
    modal.addEventListener("product-info:loaded", ({ target }) => {
      setupTonePicker(target);
    });
  });
});
